import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { CartProvider } from './context/CartContext';
import CartDrawer from './components/CartDrawer';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

import Home from './pages/Home';
const Quote = lazy(() => import('./pages/Quote'));
const Store = lazy(() => import('./pages/Store'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const Success = lazy(() => import('./pages/Success'));
const Failure = lazy(() => import('./pages/Failure'));
const ProductPage = lazy(() => import('./pages/ProductPage'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const EmailOutreach = lazy(() => import('./pages/EmailOutreach'));

// A simple fallback loader
const PageLoader = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1e1e1e', color: '#ffb86c' }}>
    <div className="loader-spinner" style={{ width: '40px', height: '40px', border: '4px solid rgba(255,184,108,0.1)', borderTop: '4px solid #ffb86c', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
    <h2>Loading OctoInk Studios...</h2>
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  // Background wake-up ping for Render free tier
  useEffect(() => {
    try {
      const API = import.meta.env.VITE_API_URL || 'https://octoink-backend.onrender.com';
      fetch(API).catch(() => {}); // Fire and forget
    } catch (e) {
      console.warn("API wake-up ping failed:", e);
    }
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <CurrencyProvider>
          <CartProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <CartDrawer />
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/store" element={<Store />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/quote/:id" element={<Quote />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/success" element={<Success />} />
                  <Route path="/failure" element={<Failure />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/admin/email" element={<EmailOutreach />} />
                  {/* Catch-all route to prevent 404s within the app */}
                  <Route path="*" element={<Home />} />
                </Routes>
              </Suspense>
            </Router>
          </CartProvider>
        </CurrencyProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
